export default __webpack_public_path__ + "static/media/host_operator.2eb291ee.svg";